import z from 'zod';
export const UserRole = {
    Admin: 'Admin',
    User: 'User',
    Judge: 'Judge',
    Organiser: 'Organiser',
    TrustedThirdParty: 'TrustedThirdParty',
    Docs: 'Docs',
} as const;
export type UserRole = (typeof UserRole)[keyof typeof UserRole];
export const UserRoleEnum = z.enum(UserRole);
